import React, { useEffect } from 'react'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import ListItemText from '@mui/material/ListItemText'
import Select from '@mui/material/Select'
import Checkbox from '@mui/material/Checkbox'



// import React, {  } from 'react'
import { useFormContext } from 'react-hook-form'
import { Controller } from "react-hook-form"
import { withTranslation } from 'react-i18next'
// import { FormControlLabel, Radio, RadioGroup } from '@mui/material'

export default withTranslation()(function MultiSelect({options, name, label, variant}) {

  const { control, watch, trigger, getValues ,  formState: { errors }} = useFormContext()
  let v = watch(name)

  useEffect(() => {
    if (v) trigger(name)
  }, [v, trigger, name])


  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <div>
          <InputLabel id={name} className="text-sm text-secondary mb-1 inline-block">{label}</InputLabel>

          <FormControl className="w-full col-span-2 check-select bg-white rounded-md">
            <Select
              labelId={name}
              id={`demo-mutiple-checkbox-${name}`}
              multiple
              name={name}
              // error={error && error[name]}
              value={getValues(name) ?? []}
              onChange={onChange}
              variant={variant ?? 'outlined'}
              className=""
              renderValue={(selected) => {
                let arr = []
                
                selected.forEach(id => {
                  let filtered = options.filter(option => +option.value === +id)[0].label
                  return arr = [...arr, filtered]
                });
                
                return selected? arr.join(', ') : 'Check your internet connection'
              }}
            >
              {
                options.map((opt) => (
                  <MenuItem key={opt.value.toString()} value={opt.value}>
                    <Checkbox checked={getValues(name)?.includes(opt.value)} />
                    {/* <Checkbox checked={options.indexOf(opt) > -1} /> */}
                    <ListItemText primary={opt.label} />
                  </MenuItem>
                ))
              }
            </Select>
            {
              errors[name] && <p className="text-sm text-red-500 text-left w-full">{errors[name].message}</p>
            }
          </FormControl>
        </div>
      )}
    />
  )
})